import { createHelpers } from 'vuex-map-fields';

const { getMemInsideField, updateMemInsideField } = createHelpers({
    getterType: `getMemInsideField`,
    mutationType: `updateMemInsideField`,
});

const state = {
    is_mem_load : true,
    access_denied: false,
    memorandum : {
        "id" : 0,
    },
    admin_rights : false,
}

// actions
const actions = {

    LOAD_MEMORANDUM_INSIDE ({commit},mem_id) {
        commit('loading',true);
        commit('accessDenied', false);
        IMC_CORE.showloading();
        api.get('/memorandums/' + mem_id + '?visit=true').then(({data}) => {
            commit('loading',false);
            IMC_CORE.hideloading();
            if(data.status === 'operation_success') {
                commit('inside_memorandum', data.data);
                actions.LOAD_MEM_ADMIN_RIGHTS({commit},mem_id);
            }
        }).catch(err => {
            IMC_CORE.hideloading();
            const statusCode = err?.response?.status ?? '';
            if(statusCode === 403) {
                commit('accessDenied', true);
            }
            commit('loading',false);
            commit('inside_memorandum', null);

            EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
        });
    },

    LOAD_MEM_ADMIN_RIGHTS({commit},mem_id) {
         api.get('/memorandums/' + mem_id+ '/admin/rights').then(({data}) => {
            if(data.status === 'operation_success') {
                commit('admin_rights', data.data);
            }
        }).catch(err => {

        });
    },

    AUTO_ACTION({commit},ids) {
        IMC_CORE.showloading();
        api.patch('/memorandums/auto_action',{
            "ids" : ids
        }).then(({data}) => {
            if(data.status === 'operation_success') {
                window.location.reload();
            }
        }).catch(err => {
            IMC_CORE.hideloading();
            EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
        });
    }



}

const getters = {
    getMemInsideField,

    getMemorandum() {
        return state.memorandum;
    },

    getAdmRights() {
        return state.admin_rights;
    },

    is_load() {
      return state.is_mem_load;
    },
    access_denied() {
        return state.access_denied;
    }

}

// mutations
const mutations = {
    updateMemInsideField,

    loading(state,loading) {
        state.is_mem_load = loading;
    },

    admin_rights(state,res) {
        try {
            state.admin_rights = (res=== "yes");
        }
        catch (e) {
            state.admin_rights = false;
        }
    },

    inside_memorandum(state,data) {
        console.log('%c ✔ Memorandum loaded:',"color: #148f32",data);

        if(data == null) {
            state.memorandum = {
                "id" : 0,
            }
        }

        else {
            state.memorandum = {...state.memorandum,...data};
        }
    },

    mem_counts (state, data) {
        state.mem_counts = [];
        if(data.length > 0) {
            data.map(menu => {
                state.mem_counts.push(menu);
            })
            EventBus.$emit('mem_count_ready',data);
        }
    },

    accessDenied(state, data) {
        state.access_denied = data;
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
